/* Number / text formatting shared by every component. */
const nf = new Intl.NumberFormat('en-US')
export const fmt = (n) => nf.format(Math.round(n || 0))
export function compact(n) {
  n = n || 0
  if (n >= 1e6) return (n / 1e6).toFixed(n >= 1e7 ? 0 : 1) + 'M'
  if (n >= 1e3) return (n / 1e3).toFixed(n >= 1e4 ? 0 : 1) + 'K'
  return fmt(n)
}
/* Bidi-safe percentage: the LRM mark keeps "44.5%" in order inside Arabic text. */
export const pctS = (v) => '‎' + v + '%'
export const pctHtml = (v) => `<span class="num-ltr">${v}%</span>`
export const d1 = (v) => Math.round(v * 10) / 10
export const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;')
export const stars = (score) => '★'.repeat(Math.round(score)) + '☆'.repeat(5 - Math.round(score))

/* Semantic colours (CSS custom properties defined in styles/dashboard.css). */
export const BUCKET_C = { VS: 'var(--sd-pos-2)', S: 'var(--sd-pos)', NU: 'var(--sd-neu)', D: 'var(--sd-neg)', VD: 'var(--sd-neg-2)' }
export const BUCKETS = [['vsat', 'VS'], ['sat', 'S'], ['neu', 'NU'], ['dis', 'D'], ['vdis', 'VD']]
export const satColorPct = (p) => (p == null ? 'var(--sd-ink-4)' : p >= 45 ? 'var(--sd-good)' : p >= 35 ? 'var(--sd-warn)' : 'var(--sd-crit)')
export const stC = (v) => (v >= 60 ? 'var(--sd-good)' : v >= 45 ? 'var(--sd-warn)' : 'var(--sd-crit)')
export const SEC_CLS = { Baladi: 'b1', Sakani: 'b2' }
export const deltaChipHtml = (d, unit) => (d == null ? '' : `<span class="sd-delta ${d >= 0 ? 'up' : 'dn'}">${d >= 0 ? '▲' : '▼'} <span class="num-ltr">${Math.abs(d1(d))}${unit || ''}</span></span>`)

/* hex colour mix */
export function mix(c1, c2, f) {
  const p = (h) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]
  const a = p(c1), b = p(c2)
  return '#' + a.map((v, i) => Math.round(v + (b[i] - v) * f).toString(16).padStart(2, '0')).join('')
}
/* sum of a {year: count} map, optionally for one year */
export const ySum = (y, yr) => { if (!y) return 0; if (yr) return +y[yr] || 0; let s = 0; for (const k in y) s += +y[k]; return s }

export const surveyName = (r, lang) => ((lang === 'ar' ? r.nameAr : r.nameEn) || r.nameEn || r.nameAr || ('#' + r.id))
export const detailName = (sv, lang) => ((lang === 'ar' ? sv.nAr : sv.nEn) || sv.nEn || sv.nAr || ('#' + sv.id))
export const period = (from, to) => ((from && to) ? (from === to ? from : from + ' → ' + to) : '—')
